(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CDN = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function boot() {
    loadScript(CDN + 'gsap.min.js')
      .then(function () { return loadScript(CDN + 'ScrollTrigger.min.js'); })
      .then(init)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ── Config ─────────────────────────────────────────────────── */

  var EASE = 'power1.out';
  var FADE = 12;
  var SLIDE = 18;
  var DURATION = 0.5;
  var STAGGER = 0.06;

  /*
   * Each entry: { trigger, targets, from, stagger?, delay? }
   *   trigger  – CSS selector for the ScrollTrigger element
   *   targets  – CSS selector(s) for animated elements (within trigger)
   *   from     – gsap.from() vars (opacity:0 is always implied)
   *   stagger  – optional override (default STAGGER)
   *   delay    – optional delay
   */
  var sections = [
    {
      trigger: '.mcs-pub-logos',
      children: [
        { sel: '.mcs-pub-logos__heading', from: { y: FADE } },
        { sel: '.mcs-pub-logos__item', from: { y: FADE * 0.5 }, stagger: 0.04, delay: 0.1 }
      ]
    },
    {
      trigger: '.mcs-product-benefits',
      children: [
        { sel: '.mcs-product-benefits__item', from: { y: FADE }, stagger: 0.06 }
      ]
    },
    {
      trigger: '.mcs-ingredients-slider',
      children: [
        { sel: '.mcs-ingredients-slider__heading', from: { y: FADE } },
        { sel: '.mcs-ingredients-slider__body', from: { y: FADE * 0.5 }, delay: 0.12 }
      ]
    },
    {
      trigger: '.mcs-science-banner',
      children: [
        { sel: '.mcs-science-banner__heading', from: { y: FADE } },
        { sel: '.mcs-science-banner__item', from: { y: FADE * 0.6, x: -SLIDE * 0.5 }, stagger: 0.07, delay: 0.12 },
        { sel: '.mcs-science-banner__image-wrap', from: { x: SLIDE }, delay: 0.1 }
      ]
    },
    {
      trigger: '.mcs-video-testimonials',
      children: [
        { sel: '.mcs-video-testimonials__heading', from: { y: FADE } },
        { sel: '.mcs-video-testimonials__slide, .swiper-slide', from: { y: FADE * 0.5 }, stagger: 0.06, delay: 0.1 }
      ]
    },
    {
      trigger: '.mcs-why-choose',
      children: [
        { sel: '.mcs-why-choose__image-wrap', from: { x: -SLIDE }, delay: 0 },
        { sel: '.mcs-why-choose__heading', from: { y: FADE }, delay: 0.1 },
        { sel: '.mcs-why-choose__item', from: { y: FADE * 0.5, x: -SLIDE * 0.4 }, stagger: 0.06, delay: 0.18 }
      ]
    },
    {
      trigger: '.mcs-comparison',
      children: [
        { sel: '.mcs-comparison__heading', from: { y: FADE } },
        { sel: '.mcs-comparison__grid-header', from: { y: FADE * 0.4 }, stagger: 0.06, delay: 0.1 },
        { sel: '.mcs-comparison__label-cell, .mcs-comparison__cell', from: { y: FADE * 0.3 }, stagger: 0.03, delay: 0.2 }
      ]
    },
    {
      trigger: '.mcs-how-to-use',
      children: [
        { sel: '.mcs-how-to-use__card', from: { y: FADE }, stagger: 0.08 }
      ]
    },
    {
      trigger: '.mcs-founder',
      children: [
        { sel: '.mcs-founder__content', from: { x: -SLIDE } },
        { sel: '.mcs-founder__image-wrap', from: { x: SLIDE }, delay: 0.1 }
      ]
    }
  ];

  /* ── Core ────────────────────────────────────────────────────── */

  function init() {
    gsap.registerPlugin(ScrollTrigger);
    hero();
    sections.forEach(revealSection);
  }

  function hero() {
    var media = document.querySelector('.sorsco-product__media');
    var info = document.querySelector('.sorsco-product__info');
    if (!media || !info) return;

    var tl = gsap.timeline({ defaults: { ease: EASE, duration: DURATION } });

    tl.from(media, { opacity: 0, x: -SLIDE, duration: 0.6 });

    var kids = info.querySelectorAll(
      '.sorsco-product__header, .sorsco-purchase, .sorsco-testimonials, .sorsco-tabs, .sorsco-badges'
    );
    if (kids.length) {
      tl.from(kids, { opacity: 0, y: FADE, stagger: 0.06 }, 0.2);
    }
  }

  function revealSection(cfg) {
    var trigger = document.querySelector(cfg.trigger);
    if (!trigger) return;

    cfg.children.forEach(function (child) {
      var els = trigger.querySelectorAll(child.sel);
      if (!els.length) return;

      gsap.from(els, {
        opacity: 0,
        x: child.from.x || 0,
        y: child.from.y || 0,
        duration: DURATION,
        ease: EASE,
        stagger: child.stagger || 0,
        delay: child.delay || 0,
        scrollTrigger: { trigger: trigger, start: 'top 88%', once: true }
      });
    });
  }

})();
